<template>
  <div id="credentials-data" class="credentials-data" v-resize="resizeDiv">

    <ChangeEmail v-if="modalActive" @cancel="modalActive = false" />

    <section class="platform-email" v-if="signedInPlatform === 'generic'">
      <header>
        <div class="info card card--rounded">
          <h2>{{ $t('account.credentials.title') }}</h2>
          <p>E-mail<br /> <b>{{ credentialKey }}</b> <helper-btn @click.native="modalActive = true"  icon="IconPencil" /></p>
        </div>
        <HelperBg class="bg card card--rounded" />
      </header>
      <div class="password card card--rounded" id="credentials-data__password" >
        <ChangePassword />
      </div>
    </section>

    <section class="platform-fb" v-else>
      <div class="info card card--rounded">
        <h2>{{ $t('account.credentials.title') }}</h2>
        <FacebookIcon />

        <p><big><strong>{{ $t('account.credentials.facebook.title') }}</strong></big></p>
        <p>{{ $t('account.credentials.facebook.text') }}</p>
      </div>
      <HelperBg class="bg card card--rounded" />
    </section>

    <footer class="status card card--rounded" v-if="canCancel">
      <ul>
<!--        <li v-if="subscriptionPeriod">-->
<!--          <p>{{ $t('account.status.subscription.type.title') }}</p>-->
<!--          <big>{{ $t('account.status.subscription.type.values')[subscriptionPeriod] }}</big>-->
<!--        </li>-->
        <li>
          <p>{{ $t('account.status.subscription.type.title') }}</p>
          <big>{{ signedInPlatform }}</big>
        </li>
        <li>
          <p>{{ $t('account.status.subscription.status.title') }}</p>
          <big>{{ $t('account.status.subscription.status.values')[subscriptionStatus.toUpperCase()] }}</big>
        </li>
        <li>
          <p>{{ $t('account.status.subscription.expiration.title') }}</p>
          <big>{{ $d(new Date(expiresAt), 'short') }}</big>
        </li>
        <li>
          <CancelSubscription />
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import resize from 'vue-resize-directive'
import { mapState } from 'vuex'
import accountComponents from '@/components/async/account'

export default {
  components: {
    ...accountComponents
  },
  name: 'credentials-data',
  data () {
    return {
      modalActive: false
    }
  },
  directives: {
    resize
  },
  computed: {
    ...mapState({
      credentialKey: state => state.user.credentialKey,
      signedInPlatform: state => state.user.signedInPlatform,
      expiresAt: state => state.user.subscription.expires_at,
      subscriptionStatus: state => state.user.subscription.status,
      subscriptionPlatform: state => state.user.subscription.platform,
      subscriptionPeriod: state => state.user.subscription.renewalPeriod
    }),
    canCancel() {
      if (this.subscriptionStatus === 'RENEW_CANCELLED') {
        return false
      }

      return this.subscriptionPlatform !== 'APP_STORE' && this.subscriptionPlatform !== 'GOOGLE_PLAY'
    }
  },
  methods: {
    resizeDiv () {
      const div = document.querySelector('#credentials-data')
      const ref = document.querySelector('#credentials-data__password')
      const bg = document.querySelector('.bg')
      if (window.innerWidth >= 1024) {
        div.style.height = ref.clientHeight + 'px'
        bg.style.height = 'auto'
      } else {
        div.style.height = 'auto'
        bg.style.height = ref.clientHeight + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.credentials-data {
  margin-bottom: 1rem;

}
strong {
  font-weight: 900;
}
.card {
  padding: 1rem 2rem;
}
.helper-bg {
  margin: 0
}
.helper-btn {
  display: inline-block;
  transform: scale(.6);
}
.bg {
  display: none;
}
section {
  >div {
    height: 100%;
  }
  >* {
    width: 100%;
    margin-bottom: 1rem;
  }
  &.platform-fb {
    color: white;
    width: auto;
    display: flex;
    >.info {
      background: #3D578E;
      margin: 0
    }
  }

  @media ($screen-sm) {
    .password {
      width: 60%;
    }
    .bg {
      display: block;
      float: right;
      width: calc(40% - 1rem);
      margin-top: 1rem
    }
  }

  @media ($screen-lg) {
    height: calc(60% - 1rem);
    >* {
      height: calc(100%);
    }
    >header {
      width: 70%;
      display: inline-flex;
    }
    .info {
      width: 60%;
    }
    .bg {
      height: auto;
      width: 40%;
      margin: 0 1rem
    }
    .password {
      float: right;
      width: 30%;
      height: auto;
      margin-bottom: 1rem;
    }
  }
}
footer {
  width: 100%;
  height: 40%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  @media ($screen-lg) {
    width: calc(70% - 1rem);
  }
  ul {
    height: 100%;
    display: flex;
    list-style-type: none;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    align-items: center;
    @media ($screen-sm) {
      flex-wrap: nowrap;
    }
    li {
      width: 50%;
      margin: 1rem 0;
      p {
        margin-top: 0
      }
    }
  }
}
</style>
